module.exports = __webpack_public_path__ + "static/media/RequestReconfirmation.63f9fdca.svg";